import { Button } from "@/components/ui/button";
import { SITE } from "@/constants/testIds";

const HERO_IMG =
  "https://images.unsplash.com/photo-1714376880837-f40388a805e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxjYW5kbGUlMjBmbGFtZSUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgwOTMxOTY3fDA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden bg-grain">
      <div
        className="absolute inset-0 candle-flicker"
        style={{
          backgroundImage: `url(${HERO_IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 hero-vignette" aria-hidden />

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 min-h-[100svh] flex flex-col justify-center pt-24 pb-20">
        <p className="reveal text-xs sm:text-sm uppercase tracking-[0.32em] text-primary/90 mb-8">
          A Song for America&apos;s 250th Anniversary
        </p>

        <h1
          data-testid={SITE.heroTitle}
          className="reveal reveal-delay-1 font-serif text-balance text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-foreground"
        >
          Shabbat Shalom,
          <br />
          <span className="italic text-primary">America.</span>
        </h1>

        <p className="reveal reveal-delay-2 mt-8 max-w-2xl text-base sm:text-lg text-foreground/75 leading-relaxed">
          A Jewish-American gratitude song for America&apos;s 250th anniversary —
          honoring freedom, family memory, and Shabbat light.
        </p>

        <div className="reveal reveal-delay-3 mt-10 max-w-2xl">
          <div className="gold-rule w-24 mb-6" />
          <p className="font-serif italic text-2xl sm:text-3xl text-foreground/90 leading-snug text-balance">
            &ldquo;America gave our families freedom.
            <br />
            We answer with light.&rdquo;
          </p>
        </div>

        <div className="reveal reveal-delay-4 mt-12 flex flex-col sm:flex-row gap-4">
          <Button
            data-testid={SITE.heroPreviewBtn}
            onClick={() => scrollTo("listen")}
            className="btn-primary rounded-none h-12 px-8 text-sm tracking-[0.18em] uppercase font-medium"
          >
            Hear the Preview
          </Button>
          <Button
            data-testid={SITE.heroJoinBtn}
            onClick={() => scrollTo("join")}
            variant="outline"
            className="btn-ghost-gold rounded-none h-12 px-8 text-sm tracking-[0.18em] uppercase font-medium bg-transparent hover:bg-transparent"
          >
            Join the Release List
          </Button>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-foreground/40">
        <span className="text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        <div className="section-divider" />
      </div>
    </section>
  );
};
